export default __webpack_public_path__ + "static/media/text-top.e6d64ceb.svg";